import { Locale } from '@infiltre/shared';
import type { ComponentType, SVGProps } from 'react';
import { FlagDE } from './FlagDE';
import { FlagEN } from './FlagEN';
import { FlagES } from './FlagES';
import { FlagFR } from './FlagFR';
import { FlagPT } from './FlagPT';

export { FlagDE } from './FlagDE';
export { FlagEN } from './FlagEN';
export { FlagES } from './FlagES';
export { FlagFR } from './FlagFR';
export { FlagPT } from './FlagPT';

export type FlagProps = SVGProps<SVGSVGElement> & { size?: number };

/** Locale → flag component lookup. Keep in sync with `LOCALES`. */
export const FLAG_BY_LOCALE: Record<Locale, ComponentType<FlagProps>> = {
  [Locale.EN]: FlagEN,
  [Locale.FR]: FlagFR,
  [Locale.ES]: FlagES,
  [Locale.DE]: FlagDE,
  [Locale.PT]: FlagPT,
};

/** Endonym — language name written in its own tongue. Independent of UI locale. */
export const NATIVE_NAME_BY_LOCALE: Record<Locale, string> = {
  [Locale.EN]: 'English',
  [Locale.FR]: 'Français',
  [Locale.ES]: 'Español',
  [Locale.DE]: 'Deutsch',
  [Locale.PT]: 'Português',
};

/** Endonym country label paired with each locale's flag. */
export const COUNTRY_BY_LOCALE: Record<Locale, string> = {
  [Locale.EN]: 'United Kingdom',
  [Locale.FR]: 'France',
  [Locale.ES]: 'España',
  [Locale.DE]: 'Deutschland',
  [Locale.PT]: 'Portugal',
};
